import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

const InstagramPost: React.FC<{
  linkStr: string;
  captioned?: boolean;
  width?: string;
}> = ({ linkStr, captioned = true, width = '35dvw' }) => {
  return (
    <div
      className="w-100"
      style={{ display: 'flex', justifyContent: 'center' }}
    >
      <InstagramEmbed
        url={linkStr}
        width={width} // Largura do embed
        captioned={captioned} // Inclui a legenda (opcional)
      />
    </div>
  );
};

export default InstagramPost;
